var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayOnDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1481,
    height: 1481,
    viewBox: "0 0 1481 1481",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1480.05,
    height: 1480.05,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2853_203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1174.69 545.864H1065.21L381.789 875.41V992.632C382.962 1026.76 410.675 1053.99 444.824 1054.56H1174.69C1207.67 1053.97 1233.92 1026.76 1233.33 993.788C1233.33 993.403 1233.32 993.018 1233.3 992.632V610.004C1235.15 576.463 1209.46 547.774 1175.93 545.919C1175.51 545.898 1175.1 545.879 1174.69 545.864Z",
    fill: "#2BA037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.66 548.088V856.622C1111.66 890.823 1083.93 918.549 1049.73 918.549H319.865C286.273 918.556 259.038 891.329 259.031 857.737C259.031 857.365 259.035 856.994 259.042 856.622V475.1C258.43 441.515 285.162 413.793 318.747 413.183C319.12 413.177 319.49 413.172 319.863 413.172H1049.73C1083.93 413.172 1111.66 440.899 1111.66 475.1V548.088H1111.66Z",
    fill: "#3BB54A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000 853.252C1024.43 853.252 1044.23 833.447 1044.23 809.017C1044.23 784.587 1024.43 764.783 1000 764.783C975.57 764.783 955.766 784.587 955.766 809.017C955.766 833.447 975.57 853.252 1000 853.252Z",
    fill: "#2BA037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.851 863.223C793.564 863.223 881.694 775.093 881.694 666.38C881.694 557.666 793.564 469.537 684.851 469.537C576.137 469.537 488.008 557.666 488.008 666.38C488.008 775.093 576.137 863.223 684.851 863.223Z",
    fill: "#2BA037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.672 565.753C394.102 565.753 413.906 545.949 413.906 521.519C413.906 497.089 394.102 477.284 369.672 477.284C345.242 477.284 325.438 497.089 325.438 521.519C325.438 545.949 345.242 565.753 369.672 565.753Z",
    fill: "#2BA037"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2853_203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 974.366,
    height: 974.366,
    fill: "white",
    transform: "translate(259.039 246.672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayOnDelivery);
export default __webpack_public_path__ + "static/media/pay-on-delivery.06552b153f1491694d87e90f0fc17c0f.svg";
export { ForwardRef as ReactComponent };